import useAndroidSafePadding from "../hooks/useAndroidSafePadding";

const AndroidPaddingWrapper = () => {
  useAndroidSafePadding();
  return null;
};

export default AndroidPaddingWrapper;